<template>
  <div class="edit-script-wrapper" v-if="dataDone">
    <div class="script-top-control">
      <div class="top-item" @click="clearHerbsShow = true">
        <icon icon-class="clear"></icon>清空药材
      </div>
      <div class="top-item " @click="saveTemplate">
        <img src="@/assets/images/icons/pre-upload.png" style="width: 23px;margin-right: 10px;" />存为模板
      </div>
      <div class="top-item" @click="getScriptPrice">
        <icon icon-class="save"></icon>处方确认
      </div>
    </div>
    <div class="herb-error-tips" v-if="hasErrorHerbs">提醒：标红药材名称与配送方不匹配，请删除后重新添加</div>
    <div class="herbs-list" ref="herbsList">
      <div class="herb-item" :class="{'error': item.is_false}" v-for="(item, index) in herbList" :key="index">
        <div class="medicine-info">
          <div class="medicine-control" @click="delMedicine(item)"><i class="delete-icon"></i></div>
          <div class="medicine-name" @click="pickSpecial(item, index)">
            <div class="name">{{item.name}}</div>
            <div class="special-method" v-if="item.remark">{{item.remark}}</div>
          </div>
          <div class="dose">
            <number-input ref="numberInput" class="dose-input" :class="{'zero': item.num == 0}" :min="0" v-model="item.num"
              :integer="item.unit != 'g'" />{{item.unit}}</div>
          <!-- <div class="medicine-error" v-else>缺药或单位不匹配</div> -->
        </div>
        <!-- <div class="medicine-control" @click="delMedicine(item)">删除</div> -->
      </div>
    </div>
    <div class="script-bottom-control">
      <div class="search-results" v-show="searchResultShow">
        <template v-if="searchDone" v-for="item in searchResult">
          <div class="result-item script" v-if="item.type != 3" @click="pickHerbItem(item)">
            <div class="script-name">{{item.title}}<span>{{item.type == 1 ? '经方' : '模板'}}</span></div>
            <div class="script-herbs">包含{{item.num || 0}}种药材</div>
          </div>
          <div class="result-item herb" @click="pickHerbItem(item)" v-else>{{item.title}}</div>
        </template>

        <div class="empty-result" v-if="searchResult.length == 0 && searchDone">暂无搜索结果</div>
        <div class="searching" v-if="!searchDone">
          <van-loading type="spinner" size="16px" />
        </div>
      </div>
      <div class="script-menu" v-show="menuShow">
        <div class="menu-item" @click="scriptPick(1)">
          <icon icon-class="history"></icon>历史处方
        </div>
        <div class="menu-item" @click="scriptPick(2)">
          <icon icon-class="template"></icon>处方模板
        </div>
        <div class="menu-item" @click="scriptPick(3)">
          <icon icon-class="classical-template"></icon>经方模板
        </div>
      </div>
      <div class="add-herb-typer" v-show="searchShow">
        <input type="text" class="herb-search-input" v-model="herbKey" v-ios-bug-fixed @focus="searchFocus" @blur="searchBlur"
          @input="searchHerbs($event)" placeholder="请输入处方或药材名称">
      </div>
      <div class="herb-unit-editor" v-show="herbDoseEditShow">
        <div class="editor-wrapper">
          <div class="herb-info"><span>{{pickedHerb.name}}</span>({{pickedHerb.unit}})</div>
          <div class="input-box">
            <number-input ref="herbUnitInput" class="unit-input" @blur="numberBlur" v-ios-bug-fixed :class="{'zero': pickedHerb.num == 0}"
              :min="0" v-model="pickedHerb.num" :integer="pickedHerb.unit != 'g'" placeholder="请输入药材数量" />
          </div>
          <button class="unit-edit-button" @click="comfirmUnit">确定</button>
        </div>
      </div>

    </div>
    <!-- 保存处方模板弹窗 -->
    <x-dialog v-if="saveToTemplateShow" title="保存为处方模板" @close="saveToTemplateShow = false">
      <div class="save-content">
        <div class="save-input">
          <div class="save-title">模板名称</div>
          <div class="save-text">
            <input type="text" class="save-typer" maxlength="15" v-model="saveTemplateName" placeholder="请输入处方名称">
            <span class="text-limit">{{saveTemplateName.length}}/15</span>
          </div>
        </div>
        <div class="save-control">
          <button class="cancel" @click="saveToTemplateShow = false">取消</button>
          <button class="confirm" @click="saveTemplateAction" :disabled="scriptSaving">保存</button>
        </div>
      </div>
    </x-dialog>
    <!-- 清空药材弹窗 -->
    <x-dialog v-if="clearHerbsShow" title="删除药材" @close="clearHerbsShow = false">
      <div class="clear-content">
        <div class="text">是否清空处方内药材？</div>
        <div class="control">
          <button class="cancel" @click="clearHerbsShow = false">取消</button>
          <button class="confirm" @click="clearHerbs">确定</button>
        </div>
      </div>
    </x-dialog>
    <!-- 药材超量弹窗 -->
    <x-dialog v-if="excessHerbsShow" title="确认保存处方" @close="excessHerbsShow = false" dialogWidth="82%">
      <div class="excess-content">
        <div class="text">
          <p class="excess-tip">当前处方存在特殊情况，请确认已知晓，并加盖电子签章</p>
          <div class="excess-text" v-if="tabooData.length > 0">
            <div class="excess-type">存在配伍禁忌</div>
            <div class="excess-data">{{tabooData.join('、')}}</div>
          </div>
          <div class="excess-text" v-if="excessData">
            <div class="excess-type">超出药典建议最大剂量</div>
            <div class="excess-data">{{excessData}}</div>
          </div>
        </div>
        <div class="control">
          <button class="cancel" @click="cancelEdit">修改</button>
          <button class="confirm" @click="saveScript">我已确认</button>
        </div>
      </div>
    </x-dialog>
    <!-- 选择特殊煎服法 -->
    <van-popup v-model="specialListShow" position="bottom" :style="{height: '60%'}">
      <div class="popup-wrapper">
        <div class="popup-header">
          {{specialIndex == null ? '特殊煎服法' : herbList[specialIndex].name}}
          <span class="close-popup" @click="specialListShow = false">取消</span>
        </div>
        <div class="data-wrapper special-list">
          <div class="special-item" :class="{'selected': item == pickedSpecial}" @click="chooseSpecial(item)" v-for="item in specialData">{{item}}</div>
        </div>
      </div>
    </van-popup>
    <x-dialog v-if="customizeSpecialShow" title="自定义" @close="customizeSpecialShow = false">
      <div class="customize-content">
        <div class="customize-text">
          <input type="text" class="customize-input" v-ios-bug-fixed ref="customizeInput" v-model="customizeSpecial">
        </div>
        <div class="customize-control">
          <button class="cancel" @click="customizeSpecialShow = false">取消</button>
          <button class="confirm" @click="saveCustomizeSpecial">保存</button>
        </div>
      </div>
    </x-dialog>
    <!-- 选择处方模板&历史处方&经方 -->
    <van-popup v-model="scriptPickShow" position="bottom" :style="{height: '100%'}">
      <div class="popup-wrapper">
        <div class="popup-header">
          {{scriptPickType | scriptPickTitle}}
          <span class="close-popup" @click="scriptPickShow = false">取消</span>
        </div>
        <div class="data-wrapper script-wrapper">
          <!-- 历史处方列表 -->
          <div class="prescription-list" v-if="scriptPickType == 1">
            <template v-if="scriptList.length > 0">
              <div class="prescription-item" v-for="item in scriptList" :key="item.prescription_id" @click="chooseScript(item.prescription_id, 3)">
                <div class="item-head">
                  <div class="item-title">{{item.create_time | dateFilter('day')}}</div>
                  <div class="sub-title">诊断: {{item.diagnose}}</div>
                </div>
                <div class="prescription-card-content">{{item.scriptString}}</div>
              </div>
            </template>
            <div class="empty-data" v-else>
              <icon icon-class="empty-template"></icon>
              <p>暂无历史处方</p>
            </div>
          </div>
          <!-- 处方模板列表 -->
          <div class="prescription-list" v-if="scriptPickType == 2">
            <template v-if="scriptList.length > 0">
              <div class="prescription-item" v-for="item in scriptList" :key="item.template_id" @click="chooseScript(item.template_id, 2)">
                <div class="item-head">
                  <div class="item-title template">{{item.title}}</div>
                </div>
                <div class="prescription-card-content">{{item.scriptString}}</div>
              </div>
            </template>
            <div class="empty-data" v-else>
              <icon icon-class="empty-template"></icon>
              <p>暂无处方模板</p>
            </div>
          </div>
          <!-- 经方模板列表 -->
          <div class="prescription-list" ref="expList" v-if="scriptPickType == 3" @scroll="scrollToLoad">
            <div class="prescription-item" v-for="item in scriptList" :key="item.id" @click="chooseScript(item.id, 1)">
              <div class="item-head">
                <div class="item-title">{{item.title}}</div>
              </div>
              <div class="prescription-card-content">{{item.scriptString}}</div>
            </div>
            <div class="data-loading" v-if="!expListIsOver">
              <van-loading type="spinner" size="14px">加载中...</van-loading>
            </div>
            <div class="data-finish" v-if="expListIsOver">无更多数据</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
  .edit-script-wrapper{
    height: 100%;
    position: relative;
    background: #FAFAFA;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .save-content{
      padding: 29px 0 47px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .save-input{
        .save-title{
          font-size: 14px;
          line-height: 14px;
          color: #666;
          font-weight: bold;
        }
        .save-text{
          position: relative;
          width: 287px;
          height: 48px;
          background: #F7F7F7;
          border-radius: 4px;
          margin-top: 12px;
          overflow: hidden;
          .save-typer{
            width: 100%;
            padding: 17px 12px;
            font-size: 14px;
            line-height: 14px;
            color: @black;
            background: #F7F7F7;
          }
          .text-limit{
            position: absolute;
            bottom: 8px;
            right: 8px;
            font-size: 12px;
            line-height: 12px;
            color: #999;
          }
        }
      }
      .save-control{
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 136px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }
    .script-top-control{
      position: relative;
      z-index: 10;
      width: 100%;
      height: 52px;
      background: #FFF;
      box-shadow: 0px 2px 6px 0px rgba(199,163,97,0.06);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .top-item-img{
        padding-left: 10px;
      }
      .top-item{
        flex: 1;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: @black;
        height: 100%;
        &:first-child::after{
          content: '';
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          width: 1px;
          height: 25px;
          background: #EEE;
        }
        &:nth-child(2)::after{
          content: '';
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          width: 1px;
          height: 25px;
          background: #EEE;
        }
        svg{
          font-size: 28px;
          margin-right: 8px;
        }
      }
    }
    .herb-error-tips{
      width: 100%;
      position: relative;
      padding: 8px 16px 8px 28px;
      background: #FCE6E7;
      color: #FF5B60;
      font-size: 13px;
      line-height: 18px;
      &::after{
        content: '';
        position: absolute;
        top: 14px;
        left: 16px;
        width: 4px;
        height: 4px;
        background: #FF5B60;
        border-radius: 50%;
      }
    }
    .herbs-list{
      overflow-y: scroll;
      width: 100%;
      flex: 1;
      -webkit-overflow-scrolling: touch;
      -webkit-overscroll-behavior: contain;
      padding: 12px 0;
      .herb-item{
        float: left;
        position: relative;
        margin-bottom: 2px;
        background: #FFF;
        width: 50%;
        height: 52px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px 0 8px;
        overflow: hidden;
        &:nth-child(2n)::after{
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          width: 1px;
          height: 28px;
          background: #EEE;
        }
        &.error{
          .medicine-info .medicine-name .name{
            color: @error;
          }
        }
        .medicine-control{
          width: 26px;
          height: 52px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
          .delete-icon{
            position: relative;
            width: 18px;
            height: 18px;
            border: 1px solid #CCC;
            border-radius: 50%;
            background: #FFF;
            &::after{
              content: '';
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 10px;
              height: 2px;
              border-radius: 1px;
              background: #999;
            }
          }
        }
        .medicine-info{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          font-size: 16px;
          font-weight: bold;
          color: @black;
          line-height: 20px;
          overflow: hidden;
          .medicine-name{
            padding-left: 4px;
            width: 68px;
            height: 100%;
            position: relative;
            // &::after{
            //   content: '';
            //   position: absolute;
            //   right: 0;
            //   top: 50%;
            //   transform: translateY(-50%);
            //   width: 1px;
            //   height: 20px;
            //   background: #EEE;
            // }
            .name{
              font-size: 15px;
              line-height: 20px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .special-method{
              font-size: 12px;
              line-height: 18px;
              color: #999;
              font-weight: normal;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
          .dose{
            padding-left: 4px;
            color: #666;
            display: flex;
            justify-content: flex-start;
            align-items: baseline;
            font-weight: normal;
            .dose-input{
              width: 50px;
              text-align: right;
              padding: 0 4px;
              color: @black;
              &.zero{
                color: @error;
              }
            }
            span{
              color: #666;
              font-weight: normal;
              margin-right: 4px;
            }
          }

          .medicine-error{
            padding-left: 12px;
            font-weight: normal;
            font-size: 14px;
            color: @error;
          }
        }
        // .medicine-control{
        //   line-height: 52px;
        //   font-size: 14px;
        //   color: #999;
        //   height: 100%;
        //   padding-left: 20px;
        //   white-space: nowrap;
        // }
      }
    }
    .script-bottom-control{
      position: relative;
      z-index: 10;
      width: 100%;
      background: #FFF;
      box-shadow: 0px 2px 6px 0px rgba(199,163,97,0.06);
      .search-results{
        width: 100%;
        height: 64px;
        overflow-x: scroll;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
        padding: 0 24px;
        .result-item{
          display: inline-flex;
          margin-right: 28px;
          height: 100%;
          &.script{
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
          }
          &.herb{
            align-items: center;
            vertical-align: top;
            font-size: 16px;
            font-weight: bold;
            color: @black;
          }
          .script-name{
            font-size: 16px;
            line-height: 22px;
            color: @black;
            font-weight: bold;
            span{
              position: relative;
              top: -2px;
              display: inline-block;
              margin-left: 6px;
              height: 16px;
              padding: 0 4px;
              font-size: 12px;
              line-height: 16px;
              font-weight: normal;
              color: #999;
              border: 1px solid #999;
            }
          }
          .script-herbs{
            margin-top: 1px;
            font-size: 12px;
            line-height: 17px;
            color: #999;
          }
        }
        .empty-result{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
          color: #999;
        }
        .searching{
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
          color: #666;
        }
      }
      .script-menu{
        height: 52px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .menu-item{
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          color: @black;
          flex: 1;
          height: 100%;
          &::after{
            content: '';
            position: absolute;
            right: 0;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            width: 1px;
            height: 25px;
            background: #EEE;
          }
          &:last-child::after{
            width: 0;
          }
          svg{
            font-size: 28px;
            margin-right: 8px;
          }
        }
      }
      .add-herb-typer{
        position: relative;
        padding: 12px 16px;
        box-shadow: 0px -2px 6px 0px rgba(199,163,97,0.06);
        z-index: 10;
        .herb-search-input{
          width: 100%;
          background: #F3F3F3;
          height: 40px;
          overflow: hidden;
          padding: 0 20px;
          font-size: 16px;
          line-height: 22px;
          border-radius: 4px;
        }
      }
      .herb-unit-editor{
        position: relative;
        padding: 12px 16px;
        box-shadow: 0px -2px 6px 0px rgba(54,104,166,0.05);
        z-index: 10;
        .editor-wrapper{
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 40px;
          padding: 6px 8px 6px 20px;
          background: #F3F3F3;
          border-radius: 4px;
          .herb-info{
            white-space: nowrap;
            display: flex;
            justify-content: flex-start;
            font-size: 15px;
            line-height: 20px;
            color: @black;
            flex-shrink: 0;
            span{
              max-width: 60px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              margin-right: 4px;
            }
          }
          .input-box{
            flex: 1;
            .unit-input{
              width: 100%;
              background: #F3F3F3;
              padding-left: 12px;
              line-height: 20px;
            }
          }
          .unit-edit-button{
            @button-base();
            flex-shrink: 0;
            width: 56px;
            height: 28px;
            font-weight: normal;
          }
        }
      }
    }
    .clear-content{
      padding: 40px 0 32px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text{
        text-align: center;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
        color: @black;
      }
      .control{
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 136px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }
    // 模板列表弹窗
    .script-wrapper{
      height: calc(100%);
    }
    .prescription-list{
      height: 100%;
      background: #FAFAFA;
      overflow-y: auto;
      -webkit-overflow-scroll: touch;
      padding: 0 16px 16px;
      .prescription-item{
        margin-top: 12px;
        width: 100%;
        border-radius: 6px;
        overflow-y: hidden;
        box-shadow: 0px 2px 10px 0px rgba(51,51,51,0.08);
        border: 1px solid transparent;
        background: #FFF;
        &.selected{
          border-color: @xile;
        }
        .item-head{
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 48px;
          border-bottom: 1px solid #F3F3F3;
          padding: 0 16px;
          background: #FAFAFA;
          .item-title{
            position: relative;
            padding-left: 19px;
            font-size: 16px;
            line-height: 18px;
            font-weight: bold;
            color: @black;
            &.template{
              max-width: 100%;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow-x: hidden;
            }
            &::after{
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              width: 4px;
              height: 16px;
              background: @xile;
              border-radius: 2px;
            }
          }
          .sub-title{
            max-width: 170px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            color: @black;
          }
        }
        .prescription-card-content{
          padding: 20px;
          font-size: 14px;
          line-height: 24px;
          color: #666;
        }
      }
    }
    // 特殊煎服法
    .special-list{
      height: 100%;
      background: #FAFAFA;
      overflow-y: auto;
      -webkit-overflow-scroll: touch;
      .special-item{
        width: 100%;
        height: 44px;
        line-height: 44px;
        font-size: 16px;
        color: @black;
        border-bottom: 1px solid #F3F3F3;
        text-align: center;
        &.selected{
          color: @xile;
        }
      }
    }
    // 自定义特殊煎服法
    .customize-content{
      padding: 20px 0 24px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .customize-text{
        width: 250px;
        .customize-input{
          width: 100%;
          height: 40px;
          font-size: 16px;
          color: @black;
          padding: 0 12px;
          background: #F7F7F7;
          border-radius: 4px;
        }
      }
      .customize-control{
        margin-top: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 119px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }
    .excess-content{
      padding: 24px 28px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .excess-tip{
        font-size: 15px;
        line-height: 21px;
        color: @black;
        text-align: left;
        font-weight: bold;
      }
      .text{
        padding-top: 4px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        font-size: 16px;
        color: @black;
        .excess-text{
          margin-top: 12px;
          font-size: 14px;
          line-height: 20px;
          text-align: left;
          .excess-type{
            color: @black;
            font-weight: normal;
          }
          .excess-data{
            margin-top: 4px;
            color: @error;
          }
        }

      }
      .control{
        margin-top: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 117px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 13px;
          }
          &.confirm{}
        }
      }
    }
  }
  // iPhone5适配
  @media screen and (device-width: 320px) and (-webkit-device-pixel-ratio: 2){
    .edit-script-wrapper .herbs-list .herb-item{
      padding: 0 8px 0 4px;
    }
    .edit-script-wrapper .herbs-list .herb-item .medicine-info .medicine-name{
      width: 55px;
    }
    .edit-script-wrapper .herbs-list .herb-item .medicine-info .dose .dose-input{
      width: 40px;
      padding: 0;
    }
  }
</style>

<script type="text/javascript">
  import numberInput from '@/components/Common/numberInput'
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        blurTimer: 200,
        // 剂型
        scriptType: parseInt(this.$route.query.script_type),
        company_name:parseInt(this.$route.query.company_name),
        dataDone: true,
        // 保存为处方模板
        saveTemplateName: '',
        saveToTemplateShow: false,

        savedTemplate: false,
        // 药材列表数据
        herbList: [],
        // 搜索框显示
        searchShow: true,
        // 药品剂量输入显示
        herbDoseEditShow: false,
        // 搜索关键字
        herbKey: '',
        // 底部处方快速选择显示
        menuShow: true,
        // 显示搜索结果
        searchResultShow: false,
        // 是否搜索完成
        searchDone: false,
        // 快速选择处方模板&经方&历史处方
        scriptPickType: 1,
        scriptPickShow: false,
        // 搜索结果
        searchResult: [],
        // 选中的药材
        pickedHerb: {
          name: '未知',
          unit: 'g',
          num: null,
        },
        // 处方保存中
        scriptSaving: false,
        // 超量药材数据
        excessData: [],
        // 禁忌药数据
        tabooData: [],
        // 清空药材弹窗
        clearHerbsShow: false,
        // 药材超量弹窗
        excessHerbsShow: false,
        // 函数防抖
        timer: null,
        // 选择的特殊煎服法
        specialIndex: null,
        pickedSpecial: '',
        specialListShow: false,
        specialData: ['无', '先煎', '后下', '烊化', '包煎', '冲服', '单包', '打碎', '焗服', '另煎（炖）', '自定义'],
        // 自定义特殊煎服法
        customizeSpecialShow: false,
        customizeSpecial: '',
        // 模板列表
        scriptList: [],
        // 经方模板列表页码
        expScriptPage: 1,
        expListIsOver: false,
        loadTimer: null,
        // 保存药材数据
        scriptHrebsData: {},
      }
    },
    created() {
      console.log(this.IsPC())
      if (this.IsPC()) {
        console.log(navigator.userAgent.toLowerCase())
        this.blurTimer = 900;
      }

      if (this.$store.state.herbsData.length > 0) {
        this.herbList = this.$store.state.herbsData;
        // 清空store中保存的临时数据
        this.$store.commit('clearHerbsData');
      }
      this.dataDone = true;
    },
    mounted() {
      document.body.className = 'full-height';
    },
    beforeDestroy() {
      document.body.className = '';
    },
    components: {
      numberInput,
      xDialog
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      scriptInfo() {
        return this.$store.state.prescriptionData || {};
      },

      hasErrorHerbs() {
        // 药品中是否存在报错的药材
        let hasError = false;
        try {
          this.herbList.forEach(item => {
            if (item.is_false) {
              throw new Error("error");
            }
          })
        } catch (e) {
          if (e.message == 'error') {
            hasError = true;
          }
        }
        return hasError;
      }
    },
    methods: {
      IsPC() {
        var userAgentInfo = navigator.userAgent.toLowerCase();
        var Agents = ["Android", "iPhone",
          "SymbianOS", "Windows Phone",
          "iPad", "iPod"
        ];
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
          if (userAgentInfo.indexOf(Agents[v].toLowerCase()) > 0) {
            flag = false;
            break;
          }
        }
        return flag;
      },
      // 保存到处方模板
      saveTemplate() {
        if (this.herbList.length <= 0) {
          this.$notify('请先添加药材');
          return;
        }
        this.saveToTemplateShow = true;
      },
      saveTemplateAction() {
        console.log(this.scriptType)
        if (!this.saveTemplateName) {
          this.$notify('请输入处方名称');
          return;
        };
        if (this.herbList.length <= 0) {
          this.$notify('请先添加一个处方');
          return;
        }
        let herbDataList = this.herbList.map(item => {
          delete item.is_false;
          return item;
        })

        this.scriptSaving = true;
        this.$root.post('/addPreTmp', {
          title: this.saveTemplateName,
          doc_id: this.userInfo.user_id,
          content: this.herbList,
          company_name:this.company_name,
          drug_type:this.scriptType,
          id: 0
        }).then(data => {
          this.scriptSaving = false;
          if (data.status == 1) {
            let message = '保存处方模板成功';
            // 标记已保存
            this.savedTemplate = true;
            this.$notify({
              background: '#00848A',
              message: message
            });
            this.saveToTemplateShow = false;
          } else {
            this.$notify(data.msg);
          }
        })

      },
      itemFixed(value) {
        console.log(value)
      },
      searchFocus($event) {
        this.menuShow = false;
      },
      searchBlur() {
        setTimeout(() => {
          this.menuShow = true;
          this.searchResultShow = false;
          this.searchResult = [];
          this.herbKey = '';
        }, this.blurTimer);
      },
      searchHerbs($event) {
        if (this.timer) clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (this.herbKey != '') {
            this.searchDone = false;
            this.searchResult = [];
            this.searchResultShow = true;
            console.log('PostData');
            console.log({
              doc_id: this.userInfo.user_id,
              search: this.herbKey,
              script_type: this.scriptType,
              company_name:this.company_name
            })
            this.$root.post('/getDrugName', {
              doc_id: this.userInfo.user_id,
              search: this.herbKey,
              script_type: this.scriptType,
              company_name:this.company_name
            }).then(data => {
              console.log(data)
              this.searchDone = true;
              this.searchResult = data || [];
            })
          }
          this.timer = null;
        }, 500)
      },
      isListedHerb(herb) {
        let index = this.herbList.findIndex(item => {
          return item.name == herb.name;
        })
        if (index != -1) {
          return true;
        } else {
          return false;
        }
      },
      pickHerbItem(item) {
        if (parseInt(item.type) == 3) {
          console.log(item);
          // 添加单味药材
          let herbData = {
            name: item.title,
            unit: item.unit,
            num: 0,
            remark: '',
            settlement_price: item.settlement_price,
            price: item.price,
            trade_price: item.trade_price,
            code: item.code,
            is_false: 0,
          }
          if (this.isListedHerb(herbData)) {
            this.$notify('同一处方内禁止添加重复药材');
            return;
          } else {
            this.herbList.push(herbData);
            this.pickedHerb = {
              name: item.title,
              unit: item.unit,
              num: 0
            }
            this.$nextTick(() => {
              this.$refs.herbsList.scrollTop = this.$refs.herbsList.scrollHeight + this.$refs.herbsList.clientHeight;
            })

          }
          this.herbDoseEditShow = true;
          this.searchShow = false;
          setTimeout(() => {
            this.menuShow = false;
          }, 60);
          this.$nextTick(() => {
            this.$refs.herbUnitInput.focus();
          })
        } else {
          // 添加模板&经方
          this.addScript(item.id, item.type, () => {
            this.$nextTick(() => {
              this.$refs.herbsList.scrollTop = this.$refs.herbsList.scrollHeight + this.$refs.herbsList.clientHeight;
            })
          });
        }
      },
      // 确认药品剂量
      comfirmUnit() {
        console.log(this.pickedHerb.num)
        this.herbList[this.herbList.length - 1].num = this.pickedHerb.num;
      },
      numberBlur() {
        setTimeout(() => {
          this.menuShow = true;
          this.searchShow = true;
          this.herbDoseEditShow = false;
        }, this.blurTimer);
      },
      // 添加模板&经方&历史处方
      addScript(id, type, callBack, scriptType = this.scriptType) {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner',
          message: '处方加载中'
        })
        this.$root.post('/getDrugList', {
          id: id,
          type: type,
          company_name: this.company_name,
        }).then(data => {
          console.log(data)
          this.$toast.clear();
          if (data && data.length > 0) {
            data.forEach(herb => {
              let herbData = {
                name: herb.name,
                unit: herb.unit,
                num: parseFloat(herb.num),
                remark: herb.remark || '',
                settlement_price: herb.settlement_price || '',
                price: herb.price,
                trade_price: herb.trade_price,
                code: herb.code || '',
                is_false: herb.is_false
              }
              if (!this.isListedHerb(herbData)) {
                this.herbList.push(herbData);
              }
            })
          }
          callBack && callBack();
        })
      },
      // 选择特殊煎服法
      pickSpecial(item, index) {
        if (this.scriptType == 2) return; //配方颗粒不显示特殊煎法
        if (item.is_false == 1) return;
        this.specialIndex = index;
        this.specialListShow = true;
        this.pickedSpecial = item.remark;
      },
      // 选中特殊煎服法
      chooseSpecial(item) {
        this.specialListShow = false;
        if (item == '无') {
          this.herbList[this.specialIndex].remark = '';
          this.specialIndex = null;
          this.pickedSpecial = '';
        } else if (item == '自定义') {
          this.customizeSpecialShow = true;
          this.$nextTick(() => {
            this.$refs.customizeInput.focus();
          })
        } else {
          this.herbList[this.specialIndex].remark = item;
          this.specialIndex = null;
          this.pickedSpecial = '';
        }
      },
      saveCustomizeSpecial() {
        if (!this.customizeSpecial) {
          this.$notify('请输入自定义的特殊煎服法');
          return;
        }
        this.herbList[this.specialIndex].remark = this.customizeSpecial;
        this.customizeSpecialShow = false;
      },
      // 删除单味药材
      delMedicine(item) {
        // 清空保存的特殊煎服法index
        this.specialIndex = null;
        let index = this.herbList.findIndex(herb => {
          return item.name == herb.name;
        })
        if (index != -1) {
          this.herbList.splice(index, 1);
        }
      },
      // 清空药材
      clearHerbs() {
        this.herbList = [];
        this.clearHerbsShow = false;
      },
      // 选择处方
      scriptPick(type) {
        this.scriptPickType = type;
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner',
          message: '加载中'
        })
        switch (type) {
          // 获取历史处方
          case 1:
            {
              this.$root.post('/getPreList', {
                pat_id: this.$route.query.pat_id,
                doc_id: this.userInfo.user_id,
                type:this.scriptType,
                company_name:this.company_name
              }).then(data => {
                this.$toast.clear();
                this.scriptToString(data);
                this.scriptList = data;

                this.scriptPickShow = true;
              })
            };
            break;
            // 获取处方模板
          case 2:
            {
               console.log("剂型")
              console.log(this.scriptType)
              this.$root.post('/getPreTmpList', {
                doc_id: this.userInfo.user_id,
                type:this.scriptType,
                company_name:this.company_name
              }).then(data => {
                this.$toast.clear();
                this.scriptToString(data);
                this.scriptList = data;
                this.scriptPickShow = true;
              })
            };
            break;
            // 获取经方模板
          case 3:
            {
              this.scriptList = [];
              this.expScriptPage = 1;
              this.getExpTemplate(() => {
                this.$toast.clear();
                this.scriptPickShow = true;
              })
            };
            break;
        }

      },
      // 获取经方模板
      getExpTemplate(callBack) {
        this.$root.post('/getClassicalPretList', {
          page: this.expScriptPage,
          count: 20,
        }).then(data => {
          this.scriptToString(data.info);
          this.scriptList = [...this.scriptList, ...data.info];
          this.expListIsOver = data.is_over == 1 ? true : false;
          callBack && callBack();
        })
      },
      // 经方模板列表滚动加载
      scrollToLoad($event) {
        if (!this.expListIsOver) {
          clearTimeout(this.loadTimer);
          this.loadTimer = setTimeout(() => {
            if (($event.target.offsetHeight + $event.target.scrollTop) == $event.target.scrollHeight) {
              this.expScriptPage++;
              this.getExpTemplate();
            }
          }, 200);
        }
      },
      // 将药材数据转为字符串
      scriptToString(data, type) {
        data.forEach(item => {
          let list = [];
          if (item.content) {
            item.content.forEach(herb => {
              let string =
                `${herb.name} ${herb.num}${herb.unit || 'g'} ${herb.remark ? '(' + herb.remark + ')' : ''}`;
              list.push(string)
            })
            item.scriptString = list.join('、');
          }
        })
        return data;
      },
      chooseScript(id, type) {
        this.addScript(id, type, () => {
          this.scriptPickShow = false;
        })
      },
      // 获取处方总价&超量数据
      getScriptPrice() {

        if (this.scriptSaving) return;
        if (this.herbList.length <= 0) {
          this.$notify('请至少添加一味药材');
          return;
        }
        let herbsError = false;
        let emptyNumber = false;
        this.herbList.forEach(item => {
          if (item.is_false) {
            herbsError = true;
            return false;
          }
          if (item.num <= 0) {
            emptyNumber = true;
            return false;
          }
        })
        if (herbsError) {
          this.$notify('请删除已标红的药材');
          return;
        }
        if (emptyNumber) {
          this.$notify('药材剂量不能为0');
          return;
        }

        this.scriptSaving = true;
        this.$root.post('/getPrePrice', {
          content: this.herbList,
          company_name: this.company_name,
        }).then(data => {
          this.excessData = data.max_dosage;
          this.tabooData = [];
          if (data.drug_taboo && data.drug_taboo.length > 0) {
            data.drug_taboo.forEach(item => {
              let tabooString = `${item.name1}与${item.name2}`;
              this.tabooData.push(tabooString);
            })
          }
          let herbDataList = this.herbList.map(item => {
            delete item.is_false;
            return item;
          })
          console.log(herbDataList);
          this.scriptSaving = false;
          // 保存药材数据到处方数据中
          console.log(data);
          this.scriptHrebsData = {
            // 药材数据
            content: this.herbList,
            // 正常价格
            normalPrice: data.price / 100,
            // 价格（分）
            originPrice: data.price,
            // 超量药数据
            excessData: data.max_dosage ? data.max_dosage.split(',') : [],
            // 禁忌药数据
            tabooData: this.tabooData,
            pushMoney: data.push_money
          }
          if (this.scriptHrebsData.excessData.length > 0 || this.tabooData.length > 0) {
            this.excessHerbsShow = true;
          } else {
            this.saveScript(data);
          }
        })
      },
      saveScript() {
        this.scriptInfo.scriptData = this.scriptHrebsData;
        this.$store.commit('setPrescriptionData', this.scriptInfo);
        this.$router.go(-1);
      },
      cancelEdit() {
        this.scriptSaving = false;
        this.excessHerbsShow = false;
      }
    },
    filters: {
      scriptPickTitle(type) {
        switch (type) {
          case 1:
            return '选择历史处方';
            break;
          case 2:
            return '选择处方模板';
            break;
          case 3:
            return '选择经方模板';
            break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Diagnose/scriptEdit.vue